module.exports = __webpack_public_path__ + "img/veronika-mendoza.b574002a.png";